import React, { Component } from 'react';
import { Field } from 'redux-form';
import { Row, Col } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { InputField } from '../Common/inputField';
import Spinner from '../../components/Widgets/spinner';

class DriverForm extends Component {
  componentDidMount() {
    this.props.resetCreateDriver();
    this.props.resetEditDriver();
  }

  handleFormSubmit(formProps) {
    if (this.props.currentDriver) {
      this.props.editDriver(formProps);
    } else {
      this.props.createDriver(formProps);
    }
  }

  render() {
    const { handleSubmit, closePT, submitting, pristine, valid } = this.props;
    const disable = (this.props.currentDriver!= null);
    return (
      <form method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this))} >
        <br />
        <Row>
          <Col xs={3}>
            <div className="form-group">
              <label><Translate value="username" /><span className="asteriksReq">*</span></label>
              <Field name="username" component={InputField} disabled={disable}/>
            </div>
          </Col>
          <Col xs={3}>
            <div className="form-group">
              <label><Translate value="email" /><span className="asteriksReq">*</span></label>
              <Field name="email" component={InputField} disabled={disable}/>
            </div>
          </Col>
          <Col xs={3}>
            <div className="form-group">
              <label><Translate value="password" /><span className="asteriksReq">*</span></label>
              <Field name="password" component={InputField}/>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={3}>
            <div className="form-group">
              <label><Translate value="first_name" /><span className="asteriksReq">*</span></label>
              <Field name="first_name" component={InputField} />
            </div>
          </Col>
          <Col xs={3}>
            <div className="form-group">
              <label><Translate value="last_name" /><span className="asteriksReq">*</span></label>
              <Field name="last_name" component={InputField} />
            </div>
          </Col>
          <Col xs={3}>
            <div className="form-group">
              <label><Translate value="short_name" /><span className="asteriksReq">*</span></label>
              <Field name="short_name" component={InputField} />
            </div>
          </Col>
        </Row>
        
        <button
          action="submit"
          className="btn btn-success buttonStyle"
          disabled={submitting || pristine}
          style={{ marginTop: '25px' }}
        >
          <em className="fa fa-save" /><Translate value="save" />
        </button>
        { this.props.isCreating || this.props.isEditing && <Spinner/> }
        { this.props.createError && <div className="alert alert-danger marginTopStyle">{JSON.stringify(this.props.createError)}</div> }
        { this.props.editError && <div className="alert alert-danger marginTopStyle">{JSON.stringify(this.props.editError)}</div> }
      </form>
    );
  }
}

export default DriverForm;



// WEBPACK FOOTER //
// ./master/jsx/components/Dispatch/driverForm.jsx